import { DEFAULT_LOCALE_ATTRIBUTE, I18N_DOMAIN_ATTRIBUTE, LOCALE_ATTRIBUTE, TIME_ZONE_ATTRIBUTE } from './localization-context';
import { CoreAttributes } from "./attributes/core-attributes";
/**
 * Implementation of LocalizationContext.
 */
export class LocalizationContextImplementation {
    /**
     * Construct LocalizationContextImplementation via builder.
     * @param builder LocalizationContextBuilder
     */
    constructor(builder) {
        this._locale = builder.locale;
        this._defaultLocale = builder.defaultLocale;
        this._timeZone = builder.timeZone;
        this._i18nDomain = builder.i18nDomain;
    }
    /**
     * Get timeZone from localization context.
     * @returns timeZone.
     */
    getTimeZone() {
        return this._timeZone;
    }
    /**
     * Get locale from localization context.
     * @returns locale.
     */
    getLocale() {
        return this._locale;
    }
    /**
     * Get default locale from localization context.
     * @returns default locale.
     */
    getDefaultLocale() {
        return this._defaultLocale;
    }
    /**
     * Gets i18nDomain
     * @returns i18nDomain.
     */
    getI18nDomain() {
        return this._i18nDomain;
    }
    /**
     * Get all attributes from localization context.
     * @returns attributes.
     */
    asAttributesMap() {
        const result = new Map([
            [LOCALE_ATTRIBUTE, this._locale],
            [DEFAULT_LOCALE_ATTRIBUTE, this._defaultLocale],
            [TIME_ZONE_ATTRIBUTE, this._timeZone],
            [I18N_DOMAIN_ATTRIBUTE, this._i18nDomain],
        ]);
        return result;
    }
    toString() {
        let stringForm = 'LocalizationContext[';
        stringForm += `${LOCALE_ATTRIBUTE}=${this.getLocale()},`;
        stringForm += `${TIME_ZONE_ATTRIBUTE}=${this.getTimeZone()},`;
        stringForm += `${DEFAULT_LOCALE_ATTRIBUTE}=${this.getDefaultLocale()},`;
        stringForm += `${I18N_DOMAIN_ATTRIBUTE}=${this.getI18nDomain()}]`;
        return stringForm;
    }
    getAttribute(attributeKey) {
        switch (attributeKey) {
            case CoreAttributes.LOCALE_KEY:
                return this.getLocale();
            case CoreAttributes.DEFAULT_LOCALE_KEY:
                return this.getDefaultLocale();
            case CoreAttributes.TIME_ZONE_KEY:
                return this.getTimeZone();
            case CoreAttributes.I18N_DOMAIN_KEY:
                return this.getTimeZone();
            default:
                return undefined;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,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